"use strict";
var AdjustmentCalculations = function(hasQuickpayAdjustment, hasOtherInvoiceAdjustments, hasAdjustments, expectedTotal, quickpayDiscountPercentage, quickpayDiscountMinimum, totalFromCarrierInvoice, otherInvoicesAdjustment, otherAdjustment) {
  var calculations = {
    actualTotalFromCarrierInvoice: function(withQuickpayAjustment, quickpayAdjustmentFromCarrierInvoice) {
      var adjusted = totalFromCarrierInvoice;
      if (withQuickpayAjustment && hasQuickpayAdjustment) {
        adjusted -= quickpayAdjustmentFromCarrierInvoice;
      }
      return adjusted < 0 ? 0 : adjusted;
    },
    actualTotalFromTMS: function(withAdjustments, withQuickpayAdjustment, quickpayAdjustmentFromTMS) {
      var adjusted = expectedTotal;
      if (withAdjustments) {
        if (hasQuickpayAdjustment && withQuickpayAdjustment) {
          adjusted -= quickpayAdjustmentFromTMS;
        }
        if (hasOtherInvoiceAdjustments) {
          adjusted -= otherInvoicesAdjustment;
        }
        if (hasAdjustments) {
          adjusted -= otherAdjustment;
        }
      }
      return adjusted < 0 ? 0 : adjusted;
    },
    quickpayDiscountAmountFromCarrierInvoice: function() {
      return this.quickpayDiscountAmount(totalFromCarrierInvoice);
    },
    adjustedTotal: function() {
      return expectedTotal - otherInvoicesAdjustment - otherAdjustment;
    },
    quickpayDiscountAmountFromTMS: function() {
      return this.quickpayDiscountAmount(this.adjustedTotal());
    },
    quickpayDiscountAmount: function(total) {
      var discountAmount = 0;
      if (total > 0) {
        discountAmount = quickpayDiscountPercentage * total / 100;
        if (quickpayDiscountMinimum > discountAmount) {
          discountAmount = quickpayDiscountMinimum;
          if (discountAmount > total) {
            discountAmount = total;
          }
        }
      }
      return discountAmount;
    },
    quickpayDiscountAmountUsed: function(source) {
      var amountUsed = "";
      var total = totalFromCarrierInvoice;
      if (source == "TMS") {
        total = this.adjustedTotal();
      }
      if (total > 0) {
        amountUsed = quickpayDiscountPercentage + "%";
        var discountAmount = quickpayDiscountPercentage * total / 100;
        if (quickpayDiscountMinimum > discountAmount) {
          if (quickpayDiscountMinimum > total) {
            quickpayDiscountMinimum = total;
          }
          amountUsed = "$" + quickpayDiscountMinimum + " Minimum";
        }
      }
      return amountUsed;
    }
  };
  return calculations;
};
export { AdjustmentCalculations };
